<script lang="ts" setup>
  import GetLicenseTypeDto from '@/modules/employees/services/interfaces/GetLicenseTypeDto'
  import DropdownWidget from '@/shared/components/chat/widgets/DropdownWidget.vue'
  import { type WidgetAction } from '../types/WidgetAction'
  import { getLicenseTypes } from '@/modules/employees/services/LicenseService'
  import { ref, reactive, onMounted, computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useUserStore } from '@/store'

  const formStatus = ref<'idle' | 'loading' | 'success' | 'error'>('idle')

  let license = reactive({
    licenseType: {
      id: '',
      entity: '',
      name: '',
      enable_continuity: false,
    },
    licenseNature: {
      id: '',
      name: '',
    },
  })

  const { user } = storeToRefs(useUserStore())

  const licenseDefinitions = ref<GetLicenseTypeDto>()

  const onLicenseTypeChange = async (event: any) => {
    const licenseType = licenseDefinitions.value?.licensesTypes?.find(
      (n) => n.id === event
    )

    license.licenseType = {
      id: licenseType?.id || '',
      entity: licenseType?.entity || '',
      name: licenseType?.name || '',
      enable_continuity: licenseType?.enable_continuity || false,
    }
  }

  const onLicenseNatureChange = (event: any) => {
    const licenseNature = licenseDefinitions.value?.licenseNatures?.find(
      (n) => n.id === event
    )
    license.licenseNature = {
      id: licenseNature?.id || '',
      name: licenseNature?.name || '',
    }
  }

  const onSubmitLicenseType = () => {
    formStatus.value = 'loading'
    console.log('Submitting license type:', licenseStrToRequest.value)
    emit('onWidgetAction', {
      action: 'saveLicense',
      payload: { licenseType: licenseStrToRequest.value },
    })
  }

  const licenseStrToRequest = computed(() => {
    return `${license.licenseType.id + '*' + license.licenseType.name}${
      license.licenseNature
        ? '|' + license.licenseNature.id + '*' + license.licenseNature.name
        : ''
    }`
  })

  onMounted(async () => {
    // Fetch license definitions from the API
    try {
      getLicenseTypes(user.value?.employeeId || '').then((response) => {
        licenseDefinitions.value = response
      })
    } catch (error) {
      console.error('Error fetching license definitions:', error)
    }
  })

  const emit = defineEmits<{
    (e: 'onWidgetAction', data: WidgetAction): void
  }>()
</script>
<template>
  <div class="license-widget">
    <div class="field">
      <label for="licenseType" class="font-medium text-700"
        >Tipo de licencia <span class="text-red-500">*</span></label
      >
      <DropdownWidget
        :options="
          licenseDefinitions?.licensesTypes?.map((l) => ({
            label: l.entity + ' - ' + l.name,
            value: l.id,
          })) || []
        "
        v-model="license.licenseType.id"
        :placeholder="'Selecciona un tipo de licencia'"
        @select="onLicenseTypeChange"
      />
    </div>
    <div class="field" v-if="license?.licenseType?.enable_continuity">
      <label for="licenseNature" class="font-medium text-700"
        >Naturaleza <span class="text-red-500">*</span></label
      >
      <DropdownWidget
        :options="
          licenseDefinitions?.licenseNatures?.map((n) => ({
            label: n.name,
            value: n.id,
          })) || []
        "
        v-model="license.licenseNature.id"
        :placeholder="'Selecciona una naturaleza de licencia'"
        @select="onLicenseNatureChange"
      />
    </div>
    <Button
      class="mt-2 text-sm font-light p-button-sm"
      label="confirmar"
      @click="onSubmitLicenseType"
      :disabled="
        !license.licenseType?.id ||
        (license.licenseType?.enable_continuity &&
          !license.licenseNature?.name) ||
        formStatus === 'loading'
      "
    />
  </div>
</template>

<style scoped>
  .license-widget {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 2rem 1.5rem;
    max-width: 430px;
    margin: 0 auto;
  }
  .field {
    margin-bottom: 1.5rem;
  }
  label {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.5rem;
    display: block;
  }
  .text-red-500 {
    font-size: 1rem;
  }
  .Button {
    width: 100%;
    font-size: 1rem;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }
</style>
